export default {
  expired: {
    en: 'This offer has expired',
  },
  mins: {
    en: 'mins',
  },
  secs: {
    en: 'sec',
  },
}
